import { DEV } from "solid-js"
import { Color } from "three"
import Unexpected from "../../../Exception/Unexpected.class"
import { VERTICES_PER_TILE } from "../../consts"
import type { VertexRGBFunctionStandardMaterialArg1 } from "../../fn/applyVertexFunctionStandardMaterial"

// const debugPinks = [
//   // new Color(0xffc0cb), // Light Pink
//   // new Color(0xff69b4), // Hot Pink
//   // new Color(0xff1493), // Deep Pink
//   // new Color(0xc71585), // Medium Violet Red
//   // new Color(0xb60474), // Medium Violet Red darker

//   [new Color(0xffffff)], // Peak - Snow White
//   [new Color(0xc0c0c0)], // Mid-High - Gray (Exposed Rock)
//   [new Color(0x8d6e63)], // Mid - Rocky Surface
//   new Color(0x6d4c41), // Mid-Low - Lighter Earthy Brown
//   new Color(0x3e2723), // Base - Dark Brown (rock/soil)
// ] as const

type MountainColorPair = {
  // height/elevation
  h: number,
  c: Color,
}

function makeMountainColor(hexCode: number, height: number): MountainColorPair {
  return {
    h: height * (VERTICES_PER_TILE / 32),
    c: new Color(hexCode),
  }
}

const mountainColors = [
  makeMountainColor(0xffffff, 15),   // Snowy Peak - white
  makeMountainColor(0xd0d0e0, 14),   // Cold Rock - light bluish-gray
  makeMountainColor(0x9c7f7f, 10),   // Mid Rock - muted dusty rose (subtle pink-gray)
  makeMountainColor(0x7a5c4b, 6),    // Lower Mid - earthy brown-gray (less orange)
  makeMountainColor(0x50332a, -1),   // Base - dark stone/soil
  makeMountainColor(0x50332a, -4),   // Base - dark stone/soil
]

export function getMountainElevationColor(height: number, tmpColor?: Color): Color {
  let h1 = 0
  let h2 = 0
  let c1: Color | undefined
  let c2: Color | undefined
  tmpColor ||= new Color()
  for (let i = 0; i < mountainColors.length; i++) {
    const { h, c } = mountainColors[i]
    h1 = h
    c1 = c
    if (height >= h) {
      if (c2) {
        return tmpColor.copy(c1).lerp(c2, (height - h1) / (h2 - h1))
      }
      return tmpColor.copy(c1)
    }
    h2 = h1
    c2 = c1
  }
  if (DEV && !c2) {
    throw new Unexpected('!c2')
  }
  return tmpColor.copy(c2!)
}

// {
//   const d = []
//   range(-5, 20, 0.5).forEach((h) => {
//     d.push({h, c: getMountainSandColor(h).getHexString()})
//   })
//   console.table(d)
// }

export function useMountainElevationColors(va: VertexRGBFunctionStandardMaterialArg1): void {
  const { y } = va
  // const { x, y, z } = va
  // const r = sqrt(x * x + z*z)

  // console.log({x: toFixed1(x), y: toFixed1(y), z: toFixed1(z), r: toFixed1(r)}, va)

  const color = getMountainElevationColor(y)

  va.r = (color.r)
  va.g = (color.g)
  va.b = (color.b)
}